<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">Not Auto publish Feed Offers</h4>
          <b-form-radio-group
            v-model="status"
            :options="statusOptions"
            button-variant="outline-primary"
            buttons
            @input="fetchOffers"
          ></b-form-radio-group>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <BTable :items="offers" :fields="fields" :busy="isTableBusy">
              <div slot="table-busy" class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
              <template #cell(feed)="{item}">
                {{ item.feed_in.legacy_client }}
              </template>
              <template #cell(title)="{item}">
                <router-link
                  :to="{
                    name: 'not-auto-publish-feed-offer',
                    params: {
                      offerId: item.id
                    }
                  }"
                  >{{
                    item.contents[1].title || item.contents[0].title
                  }}</router-link
                >
              </template>
              <template #cell(company)="{item}">
                <router-link
                  v-if="item.company"
                  :to="{
                    name: 'company',
                    params: {
                      companyId: item.company.id
                    }
                  }"
                  >{{ item.company.name_fr }}</router-link
                >
              </template>
              <template #cell(jobboards)="{item}">
                {{ listUnpublishedJobboardLabels(item.jobboards) }}
              </template>
            </BTable>
            <BPagination
              :disabled="isTableBusy"
              v-model="currentPage"
              @input="fetchOffers"
              :total-rows="total"
              :per-page="perPage"
              align="center"
              aria-controls="users-table"
            ></BPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable, BSpinner, BPagination, BFormRadioGroup } from "bootstrap-vue";

export default {
  components: {
    BTable,
    BSpinner,
    BPagination,
    BFormRadioGroup
  },
  data() {
    return {
      offers: [],
      currentPage: 1,
      perPage: 15,
      total: 0,
      isTableBusy: true,
      fields: [
        "feed",
        "title",
        "company",
        "jobboards",
        { key: "created_at", label: "date" },
        "actions"
      ],
      status: "pending",
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Pending", value: "pending" }
      ]
    };
  },
  created() {
    this.fetchOffers();
  },
  methods: {
    applyFilters() {
      this.currentPage = 1;
      this.fetchOffers();
    },
    fetchOffers() {
      this.isTableBusy = true;
      this.$http
        .get(`/enroll_admin/not-auto-publish-feed-offers`, {
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            status: this.status !== "all" ? this.status : null
          }
        })
        .then(({ data }) => {
          this.currentPage = data.current_page;
          this.total = data.total;
          this.offers = data.data;
        })
        .finally(() => {
          this.isTableBusy = false;
        });
    },
    listUnpublishedJobboardLabels(jobboards) {
      return jobboards
        .filter(jobboard => jobboard.pivot.status !== "published")
        .map(jobboard => jobboard.label)
        .join(", ");
    }
  }
};
</script>
